import { render, staticRenderFns } from "./AddReferees.vue?vue&type=template&id=c6061f5a&scoped=true"
import script from "./AddReferees.vue?vue&type=script&lang=js"
export * from "./AddReferees.vue?vue&type=script&lang=js"
import style0 from "./AddReferees.vue?vue&type=style&index=0&id=c6061f5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6061f5a",
  null
  
)

export default component.exports